import { Types } from "../actions/OperatorMainPageActions";

const initialState = {
    notifications: {},
    unPlannedActiveCounts: {},
    autonomousActiveCounts: {},
    barCodeInfo: {},
};

export const operatorMainPageReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_NOTIFICATIONS:
            return {
                ...state,
                notifications: action.payload || state.notifications,
            };
        case Types.SET_ACTIVE_COUNTS:
            return {
                ...state,
                unPlannedActiveCounts: action.payload || state.unPlannedActiveCounts,
            };
        case Types.SET_AUTONOMOUS_ACTIVE_COUNTS:
            return {
                ...state,
                autonomousActiveCounts: action.payload || state.autonomousActiveCounts,
            };
        case Types.SET_BARCODE_CONTEXT:
            return {
                ...state,
                barCodeInfo: action.payload || state.barCodeInfo,
            };

        default:
            return state;
    }
};
